import React, { useEffect, useState, useLayoutEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Grid,
  Tooltip,
  IconButton,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import moment from "moment";
import { capitalizeFirstLetter } from "../../utils/generalUtils";
import "../../Sass/Common.scss";
import HtmlTooltipMain from "Components/Common/HtmlTooltipMain";
// import { ReactComponent as Phone } from "Assets/Icons/PharmsmartIcon/phone.svg";
// import { ReactComponent as Fax } from "Assets/Icons/PharmsmartIcon/Fax.svg";
// import { ReactComponent as Other } from "Assets/Icons/PharmsmartIcon/Other.svg";
import { ReactComponent as Phone } from "../../Assets/Icons/phoneIcon.svg";
import { ReactComponent as Email } from "../../Assets/Icons/PharmsmartIcon/email (1).svg";
import { ReactComponent as Fax } from "../../Assets/Icons/FaxIco.svg";
import { ReactComponent as Other } from "../../Assets/Icons/OtherIcon.svg";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import PageLoading from "../../Components/Common/PageLoading";
import clsx from "clsx";
import Button from "../../Components/Common/Button/Button";
import { ReactComponent as NoteTextIcon } from "Assets/Icons/PharmsmartIcon/NoteTextcon.svg";
import { ReactComponent as RxIcon } from "../../Assets/Icons/RXicon.svg";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import { ReactComponent as PersonIcon } from "../../Assets/Icons/personICon.svg";
import HtmlTooltip from "Components/Common/HtmlTooltipMain";
import zIndex from "@mui/material/styles/zIndex";
const FaxDialog = React.lazy(() =>
  import("../../Components/Common/Dialog/FaxDialog")
);
const ViewOrderDialog = React.lazy(() =>
  import("../../Components/Common/Dialog/ViewOrderDialog")
);

const useStyle = makeStyles((theme) => ({
  rsOrderDetailText: {
    // fontSize: "19px !important",
    fontSize: "18px !important",
    // paddingBottom: "10px",
    // paddingTop: "10px",
  },
  tableContainer: {
    // marginBottom: "20px !important",
    // height: "auto !important",
    // padding: "0",
    padding: "0 !important",
    height: "auto !important",
    maxHeight: "calc(60vh - 180px) !important",
    minHeight: "calc(16vh - 100px) !important",
    "&>table": {
      borderBottom: "1px solid #e0e0e0 !important",
      borderRight: "1px solid #e0e0e0 !important",
      "&>thead": {
        "&>tr": {
          "&>th": {
            padding: "8px 16px",
            borderTop: "1px solid #e0e0e0 !important",
            borderRight: "0px !important",
          },
        },
      },
      "&>tbody": {
        "&>tr": {
          "&>td": {
            borderRight: "0px !important",
          },
        },
      },
    },
  },
  rsViewRxMain: {
    width: "300px",
    "&>svg": {
      width: "80px",
      height: "100px",
    },
    "&>h4": {
      display: "flex",
      fontSize: "15px !important",
      whiteSpace: "nowrap",
    },
    "&>h5": {
      fontSize: "15px !important",
      display: "flex",
      whiteSpace: "nowrap",
    },
    "&>div": {
      display: "flex",
      marginBottom: "10px",
      whiteSpace: "nowrap",
    },
  },
  rsViewColumn: {
    marginTop: "0px",
    "&>svg": {
      width: "80px",
      height: "100px",
    },
    "&>h4": {
      display: "flex",
      fontSize: "15px !important",
      whiteSpace: "nowrap",
    },
    "&>h5": {
      fontSize: "15px !important",
      display: "flex",
      whiteSpace: "nowrap",
    },
    "&> div": {
      display: "flex",
      marginBottom: "10px",
      whiteSpace: "nowrap",
    },
  },
  buttonIcon: {
    marginRight: "7px",
    height: "20px",
    width: "20px",
    fontSize: "16px !important",
    "&>path": {
      fill: theme.palette.primary.main,
    },
    "&>g": {
      "&>path": {
        fill: `${theme.palette.primary.main} !important`,
      },
    },
  },
  whiteButtonStyle: {
    marginRight: "7px",
    height: "20px",
    width: "20px",
    fontSize: "16px !important",
    "&>path": {
      fill: "#ffffff",
    },
    "&>g": {
      "&>path": {
        fill: `#ffffff !important`,
      },
    },
  },
  greyButtonStyle: {
    marginRight: "10px",
    height: "20px",
    width: "20px",
    fontSize: "16px !important",
    "&>path": {
      fill: "#5A687290!important",
    },
  },
  tableAlign: {
    padding: "10px !important",
    border: "none !important",
    width: "250px",
  },
  textJustify: {
    padding: "10px !important",
    border: "none !important",
    paddingLeft: "20px !important",
  },
  rsMainGrid: {
    // marginTop: "20px",
    // marginBottom: "20px",
  },
  rsBtnGrid: {
    marginTop: "30px",
    marginBottom: "20px",
    justifyContent: "space-around",
    "&>button": {
      fontSize: "16px !important",
      borderRadius: "5x",
      width: "115px",
    },
    "&>div": {
      "&>button": {
        fontSize: "16px !important",
        borderRadius: "5px",
        width: "115px",
      },
    },
  },
  rsCollectedStatusOne: {
    backgroundColor: "rgb(220 241 204) !important",
    border: `0.5px solid ${theme.palette.primary.main} !important`,
    color: ` ${theme.palette.primary.main} !important`,
    borderRadius: "5px !important",
    height: "25px !important",
    width: "100%",
    textTransform: "uppercase",
    "&>span": {
      fontWeight: "700 !important",
    },
  },
  rsCollectedStatusTwo: {
    backgroundColor: "rgba(233, 81, 78, 0.2) !important",
    // border: "0.5px solid #E9514E !important",
    border: "0px !important",
    color: "#E9514E !important",
    borderRadius: "5px !important",
    height: "25px !important",
    width: "100%",
    textTransform: "uppercase",
    "&>span": {
      fontWeight: "700 !important",
    },
  },
  rsMain: {
    paddingTop: "0px !important",
    paddingLeft: "24px !important",
    paddingRight: "24px !important",
  },
  rsMainDriver: {
    paddingTop: "0px !important",
    paddingBottom: "50px !important",
    paddingLeft: "24px !important",
    paddingRight: "24px !important",
  },
  subContainer: {
    padding: "0px 27px",
  },
  buttonSubmit: {
    height: "35px !important",
    width: "170px",
  },
  emailTootip: {
    backgroundColor: "#EECA3C !important",
    color: "black !important",
    marginTop: "5px !important",
    fontSize: "16px !important",
    border: "0px solid #dadde9",
    fontWeight: "400 !important",
    width: "100px !important ",
    textAlign: "center !important",
  },
  arrow: {
    "&:before": {
      backgroundColor: "#EECA3C !important",
    },
  },
  disabledEmailTootip: {
    backgroundColor: "#FF5A5A !important",
    width: "170px !important",
    textAlign: "center !important",
    color: "black !important",
    marginTop: "5px !important",
    fontSize: "16px !important",
    border: "0px solid #dadde9",
    fontWeight: "400 !important",
  },
  disabledArrow: {
    "&:before": {
      backgroundColor: "#FF5A5A !important",
    },
  },
  popper: {
    zIndex: "1300 !important",
  },
}));

const ChaseUpDialog = (props) => {
  const classes = useStyle();
  const {
    open,
    setOpen,
    collectedUncollectedListShow,
    collectionViewRxAction,
    collectionViewRxDetails,
    collectAndUncollectedViewRxDetails,
    UpdateChaseUp,
    chaseUpActiveStatus,
    collect,
    setCollect,
    getList,
    createChaseUpDetails,
    resetCollectionRxState,
    getHomeListAction,
    reordertitle,
    setReordertitle,
    showDataBasedOnRole,

    subscriptionDialog,
    setSubscritionDialog,
    loginUserDetail,
  } = props;
  const [openViewOrder, setOpenViewOrder] = useState(false);
  const [openFaxOrder, setOpenFaxOrder] = useState(false);
  const [fax, setFax] = useState(false);
  const [phone, setPhone] = useState(false);
  const [viewOrderData, setViewOrderData] = useState({});
  const [prefferedOrder, setPrefferedOrder] = useState("");
  const [previousPrefferedOrder, setPreviousPrefferedOrder] = useState("");
  const [openToolTip, setOpenToolTip] = useState(false);
  let tempCollected = 0;
  let tempRemoved = 0;

  /** api call and get data on open */

  useLayoutEffect(() => {
    if (open) {
      let payload = {
        type: collectedUncollectedListShow,
      };
      collectionViewRxAction(collectAndUncollectedViewRxDetails, payload);
    }
  }, [open]);

  useEffect(() => {
    if (open) setOpenToolTip(true);
  }, [open]);
  /**handle close */
  const handleClose = () => {
    let payLoad = {};
    setOpenToolTip(false);
    setOpen(false);
    setCollect(false);
    getHomeListAction(payLoad);
    if (reordertitle) {
      setReordertitle(false);
    }
    setPrefferedOrder("");
  };
  useEffect(() => {
    if (collectionViewRxDetails?.data?.ordering_method) {
      if (collectionViewRxDetails?.data?.ordering_method == "email") {
        if (collectionViewRxDetails?.data?.surgery?.email) {
          setPrefferedOrder(collectionViewRxDetails?.data?.ordering_method);
          setPreviousPrefferedOrder(
            collectionViewRxDetails?.data?.ordering_method
          );
        }
      } else {
        setPrefferedOrder(collectionViewRxDetails?.data?.ordering_method);
        setPreviousPrefferedOrder(
          collectionViewRxDetails?.data?.ordering_method
        );
      }
    } else {
      if (collectionViewRxDetails?.data?.surgery?.ordering_method == "email") {
        if (collectionViewRxDetails?.data?.surgery?.email) {
          setPrefferedOrder(
            collectionViewRxDetails?.data?.surgery?.ordering_method
          );
          setPreviousPrefferedOrder(
            collectionViewRxDetails?.data?.surgery?.ordering_method
          );
        }
      } else {
        setPrefferedOrder(
          collectionViewRxDetails?.data?.surgery?.ordering_method
        );
        setPreviousPrefferedOrder(
          collectionViewRxDetails?.data?.surgery?.ordering_method
        );
      }
    }
  }, [collectionViewRxDetails?.data]);
  /** handle submit  */
  const handleSubmit = (actionType) => {
    // if (loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    if (
      actionType === "mark_as_reopen" &&
      collectionViewRxDetails?.data?.surgery?.email &&
      prefferedOrder === "email"
    ) {
      let tempCollected = 0;
      let tempRemoved = 0;
      collectionViewRxDetails?.data?.patient_number_of_medication?.map(
        (item, index) => {
          if (item.status === "Collected") {
            tempCollected += parseInt(item.pnom_medication_no);
          }
          if (item.status === "Removed") {
            tempRemoved += parseInt(item.pnom_medication_no);
          }
        }
      );
      let tempCount =
        collectionViewRxDetails?.data?.number_of_medication -
        tempCollected -
        tempRemoved;
      let tempMail = `${"\r\n \r\n"} Dear ${
        collectionViewRxDetails?.data?.surgery?.name
      },${"\r\n \r\n"} Please can I order a repeat prescription for the following ${"\r\n \r\n"} Patient name: ${
        collectionViewRxDetails?.data?.name[0]
      } ${
        collectionViewRxDetails?.data?.last_name
          ? collectionViewRxDetails?.data?.last_name
          : ""
      }  ${"\r\n \r\n"} DOB : ${
        collectionViewRxDetails?.data?.dob
          ? moment(new Date(collectionViewRxDetails?.data?.dob)).format(
              "DD MMM YYYY"
            )
          : "N / A"
      }  ${"\r\n \r\n"} Medication:${
        collectionViewRxDetails?.data?.medication_type !== "number"
          ? "\r\n"
          : `${tempCount}`
      }
      ${
        collectionViewRxDetails?.data?.medication_type === "number"
          ? ` `
          : collectionViewRxDetails?.data?.patient_medications
              ?.map((item) =>
                item.status !== "Collected" && item.status !== "Removed"
                  ? `${"\r\n"} ${
                      item?.drug_name ? item?.drug_name : item?.name
                    } ${
                      item?.quantity ? `/ Quantity:${item?.quantity}` : ""
                    }  ,`
                  : ``
              )
              .join("")
      }
      ${"\r\n \r\n"} Best regards, ${"\r\n \r\n"} ${
        loginUserDetail?.data?.data?.name ||
        collectionViewRxDetails?.data?.created_by?.name ||
        "Admin"
      } ${"\r\n"}${
        collectionViewRxDetails?.data?.pharmacy?.name
      } ${"\r\n \r\n"}`;
      let payload = {
        id: collectionViewRxDetails?.data?.id,
        type: actionType,
        subject: "Prescription Order Request",
        email: collectionViewRxDetails?.data?.surgery?.email,
        message: tempMail,
      };
      UpdateChaseUp(
        collectionViewRxDetails?.data?.id,
        payload,
        chaseUpActiveStatus
      );
      handleClose();
    } else {
      let payload = {
        id: collectionViewRxDetails?.data?.id,
        type: actionType,
      };
      UpdateChaseUp(
        collectionViewRxDetails?.data?.id,
        payload,
        chaseUpActiveStatus
      );
    }
    // }
  };
  /** handle view order */
  const handleViewOrder = (
    actionType,
    medications = [],
    numberOfMedication = 0
  ) => {
    let tempCollected = 0;
    let tempRemoved = 0;
    collectionViewRxDetails?.data?.patient_number_of_medication?.map(
      (item, index) => {
        if (item.status === "Collected") {
          tempCollected += parseInt(item.pnom_medication_no);
        }
        if (item.status === "Removed") {
          tempRemoved += parseInt(item.pnom_medication_no);
        }
      }
    );
    /** collectionViewRxDetails*/
    let tempNumberOfMedication =
      collectionViewRxDetails?.data?.number_of_medication || numberOfMedication;
    let tempData = {
      medication:
        medications.length > 0
          ? medications
          : collectionViewRxDetails?.data?.patient_medications,
      surgeryName: collectionViewRxDetails?.data?.surgery?.name,
      surgeryEmail: collectionViewRxDetails?.data?.surgery?.email,
      dob: collectionViewRxDetails?.data?.dob
        ? collectionViewRxDetails?.data?.dob
        : "",
      name: collectionViewRxDetails?.data?.name,
      last_name: collectionViewRxDetails?.data?.last_name,
      medication_type: collectionViewRxDetails?.data?.medication_type,
      number_of_medication: tempNumberOfMedication,
      medicationCollected: tempCollected,
      medicationRemoved: tempRemoved,
      medicationUncollected:
        tempNumberOfMedication - tempCollected - tempRemoved,
      phone: collectionViewRxDetails?.data?.surgery?.phone,
      fax: collectionViewRxDetails?.data?.surgery?.fax,
    };
    let tempMedi = [];
    medications.map((item) => {
      if (item.status !== "Collected" && item.status !== "Removed") {
        tempMedi.push(item);
      }
    });
    let tempDataEmail = {
      medication: tempMedi,
      surgeryName: collectionViewRxDetails?.data?.surgery?.name,
      surgeryEmail: collectionViewRxDetails?.data?.surgery?.email,
      dob: collectionViewRxDetails?.data?.dob
        ? collectionViewRxDetails?.data?.dob
        : "",
      name: collectionViewRxDetails?.data?.name,
      nhs_number: collectionViewRxDetails?.data?.nhs_number,
      last_name: collectionViewRxDetails?.data?.last_name,
      medication_type: collectionViewRxDetails?.data?.medication_type,
      number_of_medication: tempNumberOfMedication,
      medicationCollected: tempCollected,
      medicationRemoved: tempRemoved,
      medicationUncollected:
        tempNumberOfMedication - tempCollected - tempRemoved,
      phone: collectionViewRxDetails?.data?.surgery?.phone,
      fax: collectionViewRxDetails?.data?.surgery?.fax,
      created_by: collectionViewRxDetails?.data?.created_by?.name || "Admin",
    };
    setViewOrderData(tempDataEmail);
    if (actionType === "email") {
      setOpenViewOrder(true);
    } else {
      setOpenFaxOrder(true);
    }
  };

  useEffect(() => {
    if (
      !createChaseUpDetails?.loading &&
      Object.keys(createChaseUpDetails?.data || {})?.length > 0
    ) {
      resetCollectionRxState("createChaseUpDetails", "");
      getList();
      handleClose();
    }
  }, [createChaseUpDetails]);
  useEffect(() => {
    let payLoad = {};
    if (createChaseUpDetails?.data?.success === true) {
      getHomeListAction(payLoad);
    }
  }, [
    createChaseUpDetails?.data?.success,
    // updateRepeatOrderData?.data?.success,
  ]);

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"md"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className="RSxs_modal"
        // className="rsDialogMain"
      >
        <PrimaryDialogTitle
          handleClose={handleClose}
          title={reordertitle ? "Reorder" : "Chase UP "}
          icon={RxIcon}
        />
        {collectionViewRxDetails?.loading ? (
          <PageLoading />
        ) : (
          <>
            <Box
              className={
                showDataBasedOnRole !== "user"
                  ? classes.rsMain
                  : classes.rsMainDriver
              }
            >
              <DialogContent className="DialogContentBox">
                {/* <DialogContent> */}
                <Grid
                  display={"flex"}
                  className={classes.rsMainGrid}
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  <Box display={"block"}>
                    <Grid display={"flex"} className={classes.rsViewRxMain}>
                      <Grid item xs={6} marginRight={"20px"}>
                        <PrimaryIcon
                          icon={PersonIcon}
                          color="primary"
                          width="20px"
                          height="20px"
                          style={{
                            marginRight: "5px",
                          }}
                        />
                        <Typography
                          regular
                          variant="h5"
                          // fontWeight="600"
                          // color={"Black"}
                          fontWeight={500}
                          fontSize={"1rem !important"}
                          color="Black"
                        >
                          {capitalizeFirstLetter(
                            collectionViewRxDetails?.data?.name
                          )}{" "}
                          {capitalizeFirstLetter(
                            collectionViewRxDetails?.data?.last_name
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} display={"flex"}>
                        <Typography
                          regular
                          variant="h5"
                          fontWeight={500}
                          fontSize={"16px !important"}
                          style={{ paddingRight: "3px", marginRight: "3px" }}
                          color="Black"
                        >
                          DOB:
                        </Typography>
                        <Typography
                          regular
                          variant="h5"
                          // fontWeight="600"
                          // color={"Black"}
                          fontWeight={400}
                          fontSize={"16px !important"}
                          color="#5A6872"
                        >
                          {collectionViewRxDetails?.data?.dob
                            ? moment(
                                new Date(collectionViewRxDetails?.data?.dob)
                              ).format("DD/MM/YYYY") || "N / A"
                            : "N / A"}
                        </Typography>
                      </Grid>
                    </Grid>

                    {/* <Grid className={classes.rsViewColumn}>
                      <Grid item xs={6} display={"flex"}>
                        <Typography
                          regular
                          variant="h5"
                          fontWeight={600}
                          fontSize={"16px !important"}
                          style={{ paddingRight: "3px", marginRight: "3px" }}
                          color="Black"
                        >
                          Dob :
                        </Typography>
                        <Typography
                          regular
                          variant="h5"
                          // fontWeight="600"
                          // color={"Black"}
                          fontWeight={600}
                          fontSize={"16px !important"}
                          color="#5A6872"
                        >
                          {collectionViewRxDetails?.data?.dob
                            ? moment(
                                new Date(collectionViewRxDetails?.data?.dob)
                              ).format("DD-MM-YYYY") || "N / A"
                            : "N / A"}
                        </Typography>
                      </Grid>
                    </Grid> */}
                  </Box>
                </Grid>

                <Grid className={classes.subContainer}>
                  <Grid className={classes.rsViewRxMain}>
                    <Grid item xs={6} display={"flex"}>
                      {/* <Typography
                          regular
                          variant="h5"
                          // fontWeight="600"
                          // color={"Black"}
                          fontWeight={500}
                          fontSize={"16px !important"}
                          style={{ paddingRight: "3px", marginRight: "3px" }}
                          color="Black"
                        >
                          Surgery :
                        </Typography> */}
                      <Typography
                        regular
                        variant="h5"
                        // fontWeight="600"
                        // color={"Black"}
                        fontWeight={400}
                        fontSize={"1rem !important"}
                        color="#5A6872"
                      >
                        {capitalizeFirstLetter(
                          collectionViewRxDetails?.data?.surgery?.name || "-"
                        )}
                      </Typography>
                    </Grid>
                  </Grid>

                  {collectionViewRxDetails?.data?.medication_type ===
                  "unspecific" ? (
                    // <Box
                    //   style={{
                    //     width: "100%",
                    //     display: "flex",
                    //     justifyContent: "center",
                    //     alignItems: "center",
                    //   }}
                    // >
                    //   <Box
                    //     style={{
                    //       display: "flex",
                    //       justifyContent: "center",
                    //       margin: "10px",
                    //       background: "#EECA3C6B",
                    //       border: "1px solid #EECA3C",
                    //       width: "30%",
                    //       padding: "5px 0px",
                    //     }}
                    //   >
                    //     <Typography
                    //       variant="h4"
                    //       style={{
                    //         color: "black",
                    //       }}
                    //     >
                    //       Medications are Unspecific.
                    //     </Typography>
                    //   </Box>
                    // </Box>
                    <Grid>
                      <Grid
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        <Typography
                          medium
                          variant="h3"
                          fontWeight={500}
                          fontSize={"1rem !important"}
                          color="#7BC044"
                          className={classes.rsOrderDetailText}
                        >
                          Order Details
                        </Typography>
                      </Grid>
                      <TableContainer className={classes.tableContainer}>
                        <Table stickyHeader>
                          <TableHead>
                            <TableRow>
                              <TableCell>DRUG</TableCell>
                              <TableCell>QUANTITY</TableCell>
                              <TableCell>STATUS</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {collectionViewRxDetails?.data?.patient_medications?.map(
                              (item, index) => {
                                return (
                                  <TableRow key={index}>
                                    <TableCell
                                      semiBold
                                      style={{
                                        marginTop: "13px",
                                        marginBottom: "11px",
                                        fontSize: "18px",
                                        fontWeight: "400",
                                        color: "black",
                                      }}
                                    >
                                      {item?.drug_name}
                                    </TableCell>
                                    <TableCell>-</TableCell>
                                    <TableCell>
                                      <Chip
                                        label={item?.status}
                                        variant="outlined"
                                        className={clsx(
                                          item?.status === "Collected"
                                            ? classes.rsCollectedStatusOne
                                            : classes.rsCollectedStatusTwo
                                        )}
                                      />
                                    </TableCell>
                                  </TableRow>
                                );
                              }
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  ) : (
                    <Grid>
                      <Grid
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        <Typography
                          medium
                          variant="h3"
                          fontWeight={500}
                          fontSize={"1rem !important"}
                          color="#7BC044"
                          className={classes.rsOrderDetailText}
                        >
                          Order Details
                        </Typography>
                      </Grid>
                      <TableContainer className={classes.tableContainer}>
                        <Table stickyHeader>
                          <TableHead>
                            {(collectionViewRxDetails?.data?.medication_type ===
                              "specific" ||
                              collectionViewRxDetails?.data?.medication_type ===
                                null) && (
                              <TableRow>
                                <TableCell>DRUG</TableCell>
                                <TableCell>QUANTITY</TableCell>
                                <TableCell>STATUS</TableCell>
                              </TableRow>
                            )}
                          </TableHead>
                          {(collectionViewRxDetails?.data?.medication_type ===
                            "specific" ||
                            collectionViewRxDetails?.data?.medication_type ===
                              null) && (
                            <TableBody>
                              {collectionViewRxDetails?.data?.patient_medications?.map(
                                (item, index) => {
                                  return (
                                    <TableRow key={index}>
                                      <TableCell semiBold>
                                        {item?.drug_name}
                                      </TableCell>
                                      <TableCell>{item?.quantity}</TableCell>
                                      <TableCell>
                                        <Chip
                                          label={item?.status}
                                          variant="outlined"
                                          className={clsx(
                                            item?.status === "Collected"
                                              ? classes.rsCollectedStatusOne
                                              : classes.rsCollectedStatusTwo
                                          )}
                                        />
                                      </TableCell>
                                    </TableRow>
                                  );
                                }
                              )}
                            </TableBody>
                          )}
                          {collectionViewRxDetails?.data?.medication_type ===
                            "number" && (
                            <TableBody>
                              <TableRow>
                                <TableCell className={classes.tableAlign}>
                                  {" "}
                                  No of medication ordered :
                                </TableCell>
                                <TableCell className={classes.textJustify}>
                                  {
                                    collectionViewRxDetails?.data
                                      ?.number_of_medication
                                  }
                                  &nbsp;
                                  {collectionViewRxDetails?.data?.patient_number_of_medication?.map(
                                    (item, index) => {
                                      if (item.status === "Collected") {
                                        tempCollected += parseInt(
                                          item.pnom_medication_no
                                        );
                                      }
                                      if (item.status === "Removed") {
                                        tempRemoved += parseInt(
                                          item.pnom_medication_no
                                        );
                                      }
                                      return null;
                                    }
                                  )}
                                  {tempCollected !== 0 || tempRemoved !== 0
                                    ? `(${tempCollected} Collected)${` `}(${tempRemoved} Removed) ${` `}(${
                                        collectionViewRxDetails?.data
                                          ?.number_of_medication -
                                        tempCollected -
                                        tempRemoved
                                      } Uncollected)`
                                    : " "}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          )}
                        </Table>
                      </TableContainer>
                    </Grid>
                  )}
                  {showDataBasedOnRole !== "user" && openToolTip && (
                    <Grid>
                      <Typography
                        medium
                        variant="h4"
                        fontWeight={500}
                        fontSize={"18px !important"}
                        color="Black"
                        padding={"20px 0px"}
                      >
                        Preferred order method
                      </Typography>
                      <Grid
                        display={"flex"}
                        className={classes.rsBtnGrid}
                        rowSpacing={1}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                      >
                        <Tooltip
                          open={true}
                          sx={{
                            "& .MuiTooltip-popper": {
                              transform: "none !important",
                            },
                          }}
                          PopperProps={{
                            disablePortal: true,
                            modifiers: [
                              {
                                name: "preventOverflow",
                                options: { boundary: "window" },
                              },
                            ],
                          }}
                          title={
                            previousPrefferedOrder === "phone"
                              ? "Preferred"
                              : ""
                          }
                          placement="top"
                          arrow
                          classes={{
                            arrow: classes.arrow,
                            tooltip: classes.emailTootip,
                            popper: classes.popper,
                          }}
                        >
                          <Grid>
                            <Button
                              variant={
                                prefferedOrder !== "phone"
                                  ? "outlined"
                                  : "contained"
                              }
                              onClick={() => {
                                setPhone(true);
                                setPrefferedOrder("phone");
                                handleViewOrder(
                                  "phone",
                                  collectionViewRxDetails?.data
                                    ?.patient_medications,
                                  collectionViewRxDetails?.data
                                    ?.number_of_medication
                                );
                              }}
                            >
                              <Phone
                                className={
                                  prefferedOrder !== "phone"
                                    ? classes.buttonIcon
                                    : classes.whiteButtonStyle
                                }
                              />
                              Phone
                            </Button>
                          </Grid>
                        </Tooltip>
                        <Tooltip
                          open={true}
                          sx={{
                            "& .MuiTooltip-popper": {
                              transform: "none !important",
                            },
                          }}
                          PopperProps={{
                            disablePortal: true,
                            modifiers: [
                              {
                                name: "preventOverflow",
                                options: { boundary: "window" },
                              },
                            ],
                          }}
                          title={
                            previousPrefferedOrder === "fax" ? "Preferred" : ""
                          }
                          placement="top"
                          arrow
                          classes={{
                            arrow: classes.arrow,
                            tooltip: classes.emailTootip,
                            popper: classes.popper,
                          }}
                        >
                          <Grid>
                            <Button
                              variant={
                                prefferedOrder !== "fax"
                                  ? "outlined"
                                  : "contained"
                              }
                              onClick={() => {
                                setFax(true);
                                setPrefferedOrder("fax");
                                handleViewOrder(
                                  "fex",
                                  collectionViewRxDetails?.data
                                    ?.patient_medications,
                                  collectionViewRxDetails?.data
                                    ?.number_of_medication
                                );
                              }}
                            >
                              <Fax
                                className={
                                  prefferedOrder !== "fax"
                                    ? classes.buttonIcon
                                    : classes.whiteButtonStyle
                                }
                              />
                              Fax
                            </Button>
                          </Grid>
                        </Tooltip>
                        <Tooltip
                          open={true}
                          sx={{
                            "& .MuiTooltip-popper": {
                              transform: "none !important",
                            },
                          }}
                          PopperProps={{
                            disablePortal: true,
                            modifiers: [
                              {
                                name: "preventOverflow",
                                options: { boundary: "window" },
                              },
                            ],
                          }}
                          title={
                            collectionViewRxDetails?.data?.surgery?.email
                              ? previousPrefferedOrder === "email"
                                ? "Preferred"
                                : ""
                              : "No email available"
                          }
                          placement="top"
                          arrow
                          classes={{
                            arrow:
                              collectionViewRxDetails?.data?.surgery
                                ?.ordering_method === "email"
                                ? collectionViewRxDetails?.data?.surgery?.email
                                  ? classes.arrow
                                  : classes.disabledArrow
                                : classes.disabledArrow,
                            // collectionViewRxDetails?.data?.surgery
                            //   ?.ordering_method === "email"
                            //   ? classes.arrow
                            //   : classes.disabledArrow,
                            tooltip:
                              collectionViewRxDetails?.data?.surgery
                                ?.ordering_method === "email"
                                ? collectionViewRxDetails?.data?.surgery?.email
                                  ? classes.emailTootip
                                  : classes.disabledEmailTootip
                                : classes.disabledEmailTootip,
                            // collectionViewRxDetails?.data?.  surgery
                            //   ?.ordering_method === "email"
                            //   ? classes.emailTootip
                            //   : classes.disabledEmailTootip,
                            popper: classes.popper,
                          }}
                        >
                          <Grid>
                            <Button
                              variant={
                                prefferedOrder !== "email"
                                  ? "outlined"
                                  : "contained"
                              }
                              disabled={
                                collectionViewRxDetails?.data?.surgery?.email
                                  ? false
                                  : true
                              }
                              color="primary"
                              onClick={() => {
                                if (
                                  collectionViewRxDetails?.data?.surgery?.email
                                ) {
                                  setPrefferedOrder("email");
                                  handleViewOrder(
                                    "email",
                                    collectionViewRxDetails?.data
                                      ?.patient_medications,
                                    collectionViewRxDetails?.data
                                      ?.number_of_medication
                                  );
                                }
                              }}
                            >
                              <Email
                                className={
                                  collectionViewRxDetails?.data?.surgery?.email
                                    ? prefferedOrder !== "email"
                                      ? classes.buttonIcon
                                      : classes.whiteButtonStyle
                                    : classes.greyButtonStyle
                                }
                              />
                              Email
                            </Button>
                          </Grid>
                        </Tooltip>

                        <Tooltip
                          open={true}
                          sx={{
                            "& .MuiTooltip-popper": {
                              transform: "none !important",
                            },
                          }}
                          PopperProps={{
                            disablePortal: true,
                            modifiers: [
                              {
                                name: "preventOverflow",
                                options: { boundary: "window" },
                              },
                            ],
                          }}
                          title={
                            previousPrefferedOrder === "other"
                              ? "Preferred"
                              : ""
                          }
                          placement="top"
                          arrow
                          classes={{
                            arrow: classes.arrow,
                            tooltip: classes.emailTootip,
                            popper: classes.popper,
                          }}
                        >
                          <Grid>
                            <Button
                              variant={
                                prefferedOrder !== "other"
                                  ? "outlined"
                                  : "contained"
                              }
                              onClick={() => {
                                setPrefferedOrder("other");
                                handleViewOrder(
                                  "other",
                                  collectionViewRxDetails?.data
                                    ?.patient_medications,
                                  collectionViewRxDetails?.data
                                    ?.number_of_medication
                                );
                              }}
                            >
                              <Other
                                className={
                                  prefferedOrder !== "other"
                                    ? classes.buttonIcon
                                    : classes.whiteButtonStyle
                                }
                              />
                              Other
                            </Button>
                          </Grid>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </DialogContent>
            </Box>
            {showDataBasedOnRole !== "user" && (
              <DialogActions style={{ paddingBottom: "25px" }}>
                <Button
                  className={classes.buttonSubmit}
                  children={
                    prefferedOrder === "email"
                      ? "Resend email"
                      : "Mark as reordered"
                  }
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    handleSubmit("mark_as_reopen");
                  }}
                />
                {!reordertitle && (
                  <Button
                    className={classes.buttonSubmit}
                    variant="contained"
                    onClick={() => {
                      collect
                        ? handleSubmit("chase_up")
                        : handleSubmit("ready_to_collect");
                    }}
                  >
                    {collect ? "Mark as chase up" : "Ready to collect"}
                  </Button>
                )}
              </DialogActions>
            )}
          </>
        )}
      </Dialog>
      <ViewOrderDialog
        open={openViewOrder}
        actionType={"Chaseup"}
        setOpen={setOpenViewOrder}
        body={collectionViewRxDetails}
        viewOrderData={viewOrderData}
        actionTypeChaseUP="mark_as_reopen"
        collectionViewRxDetails={collectionViewRxDetails}
        chaseUpActiveStatus={chaseUpActiveStatus}
        UpdateChaseUp={UpdateChaseUp}
        setViewOrderData={setViewOrderData}
        setChaseupClose={setOpen}
        subscriptionDialog={subscriptionDialog}
        setSubscritionDialog={setSubscritionDialog}
        sendMail
        fromChaseup
      />
      <FaxDialog
        open={openFaxOrder}
        actionType={"Chaseup"}
        setOpen={setOpenFaxOrder}
        body={collectionViewRxDetails}
        phone={phone}
        setPhone={setPhone}
        fax={fax}
        setFax={setFax}
        viewOrderData={viewOrderData}
      />
    </>
  );
};

export default ChaseUpDialog;
